const hasQuote = false;
export const isOrderingReleased = false;
export default hasQuote;
